const noop = () => {};
const noopFormat = () => ({ transform: (i: any) => i });

const noopInstance = () => ({ transform: (i: any) => i });

export const format: any = Object.assign((..._args: any[]) => noopInstance, {
  combine: noopFormat,
  printf: noopFormat,
  colorize: noopFormat,
  errors: noopFormat,
  splat: noopFormat,
  timestamp: noopFormat,
  metadata: noopFormat,
  json: noopFormat
});
export const transports = { Console: class {} };
export const createLogger = () => ({
  error: noop,
  warn: noop,
  info: noop,
  http: noop,
  verbose: noop,
  debug: noop,
  silly: noop
});
export default { createLogger, format, transports };
